// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__rVi5E","gray":"Keyboard_gray__uXn3T","yellow":"Keyboard_yellow__7Kvs+","green":"Keyboard_green__Rv1X-","listen_button":"Keyboard_listen_button__b5anJ"};